import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges } from "@angular/core";
import { CampaignsService } from "src/app/pages/campaign-module/campaigns/campaigns.service";
import { debounceTime, filter, distinctUntilChanged, map } from 'rxjs/operators';
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { PATTERN_NUMERIC } from "src/app/utils/constant";
import * as _ from "lodash";

@Component({
  selector: "esc-step-four",
  templateUrl: "./step-four.component.html",
  styleUrls: ["./step-four.component.scss"]
})
export class StepFourComponent implements OnInit {
  @Input() pre_generated_max_qty;
  @Input() on_demand_max_qty;
  @Input() viewMode;
  @Output() getCouponQty = new EventEmitter;

  constructor(
    private fb: FormBuilder,
    private campService: CampaignsService,
  ) { }

  public formGroup: FormGroup;
  preGenDisabled = false;
  onDemandDisabled = false;

  couponTypes = [
    {
      code: "0",
      description: "Pre-Generated",
      type:"PG"
    },
    {
      code: "1",
      description: "On Demand",
      type:"OD"
    }
  ];

  ngOnInit() {
    this.initForm();
    this.detectFormChanges();
    // console.log(this.pre_generated_max_qty, this.on_demand_max_qty);
  }

  initForm() {
    this.formGroup = this.fb.group({
      coupon_type: [this.couponTypes[0], Validators.required],
      pre_generated: [null, [Validators.required, Validators.min(1), Validators.pattern(PATTERN_NUMERIC)]],
      on_demand: [null, [Validators.required, Validators.min(1), Validators.pattern(PATTERN_NUMERIC)]]
    });

    if(_.has(this, 'pre_generated_max_qty') && (_.get(this, 'pre_generated_max_qty') > 0)) {
      this.formGroup.get('pre_generated').setValidators([
        Validators.required,
        Validators.min(1),
        Validators.max(_.get(this, 'pre_generated_max_qty')), 
        Validators.pattern(PATTERN_NUMERIC)
      ])
      if(!_.has(this, 'on_demand_max_qty') || (_.get(this, 'on_demand_max_qty') == 0)) {
        this.formGroup.get('coupon_type').disable();
      } else {
        this.formGroup.get('coupon_type').enable();
      }
    }

    if(_.has(this, 'on_demand_max_qty') && (_.get(this, 'on_demand_max_qty') > 0)) {
      this.formGroup.get('on_demand').setValidators([
        Validators.required,
        Validators.min(1),
        Validators.max(_.get(this, 'on_demand_max_qty')), 
        Validators.pattern(PATTERN_NUMERIC)
      ])
      if(!_.has(this, 'pre_generated_max_qty') || (_.get(this, 'pre_generated_max_qty') == 0)) {
        this.formGroup.get('coupon_type').setValue(this.couponTypes[1]);
        this.formGroup.get('coupon_type').disable();
      } else {
        this.formGroup.get('coupon_type').enable();
      }
    }
    if(this.viewMode) {
      this.formGroup.disable();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.formGroup && changes.pre_generated_max_qty && changes.pre_generated_max_qty.currentValue) { 
      this.formGroup.get('pre_generated').setValidators([
        Validators.required,
        Validators.min(1),
        Validators.max(_.get(this, 'pre_generated_max_qty')), 
        Validators.pattern(PATTERN_NUMERIC)
      ])
      this.formGroup.get('coupon_type').setValue(this.couponTypes[0]);
      if(!_.has(this, 'on_demand_max_qty') || (_.get(this, 'on_demand_max_qty') == 0)) {
        this.formGroup.get('coupon_type').disable();
      } else {
        this.formGroup.get('coupon_type').enable();
      }
    }

    if(this.formGroup && changes.on_demand_max_qty && changes.on_demand_max_qty.currentValue) { 
      this.formGroup.get('on_demand').setValidators([
        Validators.required,
        Validators.min(1),
        Validators.max(_.get(this, 'on_demand_max_qty')), 
        Validators.pattern(PATTERN_NUMERIC)
      ])
      this.formGroup.get('coupon_type').setValue(this.couponTypes[1]);
      if(!_.has(this, 'pre_generated_max_qty') || (_.get(this, 'pre_generated_max_qty') == 0)) {
        this.formGroup.get('coupon_type').setValue(this.couponTypes[1]);
        this.formGroup.get('coupon_type').disable();
      } else {
        this.formGroup.get('coupon_type').enable();
      }
    }
  }

  detectFormChanges() {
    this.formGroup.get("coupon_type").valueChanges.subscribe(value => {
      this.couponTypeToggle(value);
    });

    this.formGroup.get("pre_generated").valueChanges.pipe(
      debounceTime(300),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      if(value && (parseInt(value) > 0) && (value <= this.pre_generated_max_qty)) {
        let retObj = {
          generation_type: "PG",
          quantity: value
        }
        this.getCouponQty.next(retObj);
      } else {
        this.getCouponQty.next(null);
      }
    });

    this.formGroup.get("on_demand").valueChanges.pipe(
      debounceTime(300),
      filter((term) => !_.isObject(term)),
      distinctUntilChanged(),
      map((term: string) => _.trim(term)),
    )
    .subscribe(value => {
      if(value && (parseInt(value) > 0) && (value <= this.on_demand_max_qty)) {
        let retObj = {
          generation_type: "OD",
          quantity: value
        }
        this.getCouponQty.next(retObj);
      } else {
        this.getCouponQty.next(null);
      }
    });
  }

  couponTypeToggle(value) {
    this.formGroup.get("pre_generated").setValue(null);
    this.formGroup.get("on_demand").setValue(null);

    switch (_.get(value, 'code')) {
      case "0": {
        this.formGroup.get("pre_generated").enable();
        this.formGroup.get("on_demand").disable();
        break;
      }

      case "1": {
        this.formGroup.get("pre_generated").disable();
        this.formGroup.get("on_demand").enable();
        break;
      }
    }
  }
}
